// Login owns navigation on the login page. Reloading when its session changes
// races with signIn() and can cancel the transition to the authenticated page.
export function shouldRefreshIdentity(previous: string | undefined, current: string, pathname: string, busy: boolean) {
    return previous !== undefined && previous !== current && !busy && pathname !== '/login';
}
